"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toUtcCalendarDay = toUtcCalendarDay;
exports.fromUtcCalendarDay = fromUtcCalendarDay;
exports.formatUtcCalendarDay = formatUtcCalendarDay;
const date_fns_1 = require("date-fns");
const UTC_TIMEZONE = 'UTC';
/**
 * Converts a day picked in the browser (local midnight) to the same calendar
 * day at UTC midnight, which is what a date-only (`@db.Date`) column stores.
 * Without this, a Paris user picking 30 June sends `29T22:00Z` and the column
 * keeps the 29th.
 *
 * @param date - Local-midnight date from a date picker.
 * @returns The same calendar day at UTC midnight.
 */
function toUtcCalendarDay(date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
}
/**
 * Converts a date-only value read from the API (UTC midnight) to local
 * midnight of the same calendar day, so a date picker shows the stored day
 * whatever the viewer timezone.
 *
 * @param date - UTC-midnight date from the API.
 * @returns The same calendar day at local midnight.
 */
function fromUtcCalendarDay(date) {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}
/**
 * Formats a date-only value read from the API (UTC midnight) as a calendar
 * day in the viewer's locale, without shifting it with the viewer timezone.
 *
 * @param date - UTC-midnight date from the API.
 * @returns The formatted day, e.g. `30/06/2027`.
 */
function formatUtcCalendarDay(date) {
    return (0, date_fns_1.intlFormat)(date, { timeZone: UTC_TIMEZONE });
}
